import { isEmpty } from 'lodash'

export const transformEmployeeRoleToDisplay = (role) => {
  if (isEmpty(role)) return 'N/A'

  return role === 'manager' ? 'Manager' : 'Cashier'
}

export const transformEmployeeRoleToSend = (role) => {
  switch (role) {
    case 'manager':
      return ['manager']
    case 'cashier':
      return ['supervisor', 'cart_attendant', 'suite_attendant']
    default:
      return null
  }
}

export const transfromActiveValueToSend = (value) => {
  switch (value) {
    case 'active':
      return true
    case 'inactive':
      return false
    default:
      return null
  }
}

export const getValidEmployeeId = (employeeId, orgName, name) => {
  const generatedEmployeeId = generateEmployeeId(orgName, name)

  // if employeeId field is filled, return it - no matter if we craete or update
  // otherwise return generated employeeId
  return isEmpty(employeeId) ? generatedEmployeeId : employeeId
}

export const generateEmployeeId = (orgName, name) => {
  const transformedName = name?.replace(/\s/g, '_')

  const randomString = getRandomAlphaNumericString(-6)

  return `${orgName}_${transformedName}_${randomString}`.toLowerCase()
}

// provide negative number to get random string of that length
export const getRandomAlphaNumericString = (length = -6) =>
  Math.random().toString(36).slice(length)

export const orgAttendantsFileErrorMessagesCodes = {
  INVALID_HEADERS: 'invalidHeaders',
  INVALID_PIN_LENGTH: 'invalidLengthPin',
  DUPLICATE_PIN: 'duplicatePin',
  INVALID_ROLE: 'invalidRole',
  INVALID_FILE: 'invalidFile',
  EMPTY_FIELDS: 'emptyFields',
  // API error message
  EXISTING_PIN:
    'Validation failed: PIN already exists in the current organization',
}

export const orgAttendantsFileErrorMessages = new Map([
  [
    orgAttendantsFileErrorMessagesCodes.INVALID_HEADERS,
    'Invalid column headers. Please download the template and upload again.',
  ],
  [
    orgAttendantsFileErrorMessagesCodes.INVALID_PIN_LENGTH,
    'The PIN provided is not the required 5-6 digits long.',
  ],
  [
    orgAttendantsFileErrorMessagesCodes.DUPLICATE_PIN,
    'The PIN provided is not unique.',
  ],
  [
    orgAttendantsFileErrorMessagesCodes.INVALID_ROLE,
    'The role provided does not exist.',
  ],
  [
    orgAttendantsFileErrorMessagesCodes.INVALID_FILE,
    'Invalid column headers. Please download the template and upload again.',
  ],
  [
    orgAttendantsFileErrorMessagesCodes.EXISTING_PIN,
    'The PIN provided already exists in the current organization.',
  ],
  [
    orgAttendantsFileErrorMessagesCodes.EMPTY_FIELDS,
    'Missing required fields.',
  ],
])

// transform the parsed CSV file to meet the requirements of the API
const transformParsedCSVFileToAttendantsAndRoles = (
  parsedFile = [],
  orgName
) => {
  const attendantsData = parsedFile?.reduce((acc, row) => {
    // attendant and employee role data
    const employeeId = generateEmployeeId(
      orgName,
      row['First and Last Name']
    )

    acc = {
      attendantsData: [
        ...(acc?.attendantsData ?? []),
        {
          employeeId,
          name: row['First and Last Name'],
          pinNumber: row['PIN'],
        },
      ],
      employeeRolesData: [
        ...(acc?.employeeRolesData ?? []),
        {
          employeeId,
          role:
            row['Role'].toLowerCase() === 'manager'
              ? 'manager'
              : 'cart_attendant',
          type:
            row['Role'].toLowerCase() === 'manager'
              ? 'ManagerEmployeeRole'
              : 'AttendantEmployeeRole',
        },
      ],
    }

    return acc
  }, {})

  return {
    attendants: attendantsData.attendantsData,
    employeeRoles: attendantsData.employeeRolesData,
  }
}

export const posAccountsUtils = {
  transformEmployeeRoleToDisplay,
  transformEmployeeRoleToSend,
  transfromActiveValueToSend,
  getValidEmployeeId,
  generateEmployeeId,
  getRandomAlphaNumericString,
  transformParsedCSVFileToAttendantsAndRoles,
}
